import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

const ROUTE_TYPE_TO_DOC_TYPE: Record<string, string> = {
  'invoice':       'factura',
  'delivery-note': 'albaran',
  'refund':        'devolucion',
};

@Injectable({ providedIn: 'root' })
export class DocTypeGuard {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const routeType = route.params?.['type'] as string | undefined;
    const docType: string | null =
      (route.data?.['docType'] as string | undefined) ??
      (routeType ? ROUTE_TYPE_TO_DOC_TYPE[routeType] : null) ??
      null;

    if (!docType) return true;

    const allowed = this.authService.getAllowedDocumentTypes();
    if (allowed === null || allowed.includes(docType)) return true;

    this.router.navigate(['/sales']);
    return false;
  }
}
